export const formatData = data => {
    // iterate through goals
    let i,
      len = data.Goals.length;
    for (i = 0; i < len; i++) {
      // footer nav prev/next buttons

      // next
      if (!ADV.util.isEmpty(data.Goals[i + 1])) {
        data.Goals[i].next = {
          id: data.Goals[i + 1].GoalId,
          title: data.Goals[i + 1].GoalName,
        };
      }

      // prev
      if (i > 0 && !ADV.util.isEmpty(data.Goals[i - 1])) {
        data.Goals[i].prev = {
          id: data.Goals[i - 1].GoalId,
          title: data.Goals[i - 1].GoalName,
        };
      }

      // add icon type
      switch (data.Goals[i].GoalType) {
        case 'retirement':
          data.Goals[i].icon = 'fa fa-retirement';
          break;
        case 'education':
          data.Goals[i].icon = 'fa fa-graduation-cap';
          break;
        case 'insurance':
          data.Goals[i].icon = 'fa fa-umbrella';
          break;
        case 'emergencyfund':
          data.Goals[i].icon = 'adv-icon adv-icon-emergency';
          break;
        case 'homePurchase':
          data.Goals[i].icon = 'fa fa-home';
          break;
        case 'healthCare':
          data.Goals[i].icon = 'fa fa-healthCare';
          break;
        case 'debtmanagement':
          data.Goals[i].icon = 'fa fa-credit-card';
          break;
        case 'estatePlanning':
          data.Goals[i].icon = 'fas fa-clipboard';
          break;
        default:
          if (data.Goals[i].GoalName === 'Buy a car') {
            data.Goals[i].icon = 'fa fa-car';
          } else {
            data.Goals[i].icon = 'fa fa-dollar-sign';
          }
          break;
      }

      // add icon types and indexes for GoalCharts
      if (data.Goals[i].GoalCharts) {
        var j,
          len2 = data.Goals[i].GoalCharts.length;
        for (j = 0; j < len2; j++) {
          // add icon type
          switch (data.Goals[i].GoalCharts[j].Type) {
            case 'BarChart':
              data.Goals[i].GoalCharts[j].icon = 'chart-bar';
              break;
            case 'BarChartIncomeBreakdown':
              data.Goals[i].GoalCharts[j].icon = 'chart-bar';
              break;
            case 'AreaChart':
              data.Goals[i].GoalCharts[j].icon = 'chart-area';
              break;
            default:
              data.Goals[i].GoalCharts[j].icon = 'chart-line';
              break;
          }
          // add index
          data.Goals[i].GoalCharts[j].index = j;
          // since this file isn't used by the PDF, let's remove any non-pdf charts
          if (data.Goals[i].GoalCharts[j].PdfOnly) {
            let c1 = data.Goals[i].GoalCharts.slice(0, j),
              c2 = data.Goals[i].GoalCharts.slice(j + 1, data.Goals[i].GoalCharts.length);
            data.Goals[i].GoalCharts = c1.concat(c2);
          }
        }
      }
    }
    return data;
  },
  getGoal = (data, goalId) => {
    const goal = data.Goals.find(goal => goal.GoalId == goalId);
    if (!goal) {
      return {};
    }
    return goal;
  },
  getGoalIndex = (data, goalId) => {
    const index = data.Goals.findIndex(goal => goal.GoalId == goalId);
    if (index < 0) {
      return 0;
    }
    return index;
  },
  makePercentageOfSuccess = probabilityOfSuccess => {
    if (!ADV.util.isNumeric(probabilityOfSuccess)) {
      return '';
    }
    return `${Math.round(probabilityOfSuccess * 100)}%`;
  },
  makeMonteCarloSuccessRange = monteCarloSuccessRange => {
    if (!ADV.util.isNumeric(monteCarloSuccessRange)) {
      return '';
    }
    return `${Math.round(monteCarloSuccessRange * 100)}`;
  };
